module.exports = __webpack_public_path__ + "static/media/oleos-lubrificantes.a0812a75.png";